import { usePremiumIntent, useStandardIntent } from "@/components/user-context";

import { LoggedInConfluenceFree } from "./free";
import { LoggedInConfluencePremium } from "./premium";
import { LoggedInConfluenceStandard } from "./standard";

export const LoggedInConfluence = () => {
    const isStandard = useStandardIntent();
    const isPremium = usePremiumIntent();

    if (isStandard) {
        return <LoggedInConfluenceStandard />;
    }

    if (isPremium) {
        return <LoggedInConfluencePremium />;
    }

    return <LoggedInConfluenceFree />;
};
